import { render } from "./ExitDeclarationStatusesIndexPage.vue?vue&type=template&id=184d6944&scoped=true"
import script from "./ExitDeclarationStatusesIndexPage.vue?vue&type=script&lang=js"
export * from "./ExitDeclarationStatusesIndexPage.vue?vue&type=script&lang=js"

import "./ExitDeclarationStatusesIndexPage.vue?vue&type=style&index=0&id=184d6944&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184d6944"]])

export default __exports__